import { buildSavedViewFiltersJson, parseSavedViewFilters } from '../../shared/saved-views/saved-view-filters';

/** Gespeicherter Filter der Elemente-Übersicht (NEX-2447): ohne Suche `""`, ohne Tags `null`. */
export interface ObjectMappingSavedViewFilters {
  search: string;
  tags: string[] | null;
}

const EMPTY_FILTERS: ObjectMappingSavedViewFilters = { search: '', tags: null };

/** Fehlende oder falsche Felder laden als „keine Suche“ und „alle Tags“. */
export function parseObjectMappingSavedViewFilters(filtersJson: string | null): ObjectMappingSavedViewFilters {
  const filters = parseSavedViewFilters(filtersJson, EMPTY_FILTERS);
  const search: unknown = filters.search;
  const tags: unknown = filters.tags;
  return {
    search: typeof search === 'string' ? search : '',
    tags: Array.isArray(tags) ? tags.filter((tag): tag is string => typeof tag === 'string') : null,
  };
}

export function buildObjectMappingSavedViewFiltersJson(search: string, tags: readonly string[]): string {
  const filters: ObjectMappingSavedViewFilters = { search, tags: tags.length > 0 ? [...tags] : null };
  return buildSavedViewFiltersJson(filters);
}
